export const Loading: React.FC = () => {
	return (
		<div className="text-center">
			<div className="relative w-24 h-24 mx-auto mb-8">
				<div className="absolute inset-0">
					<div className="w-6 h-6 bg-(--color-accent-hover) text-(--color-text) rounded-full absolute top-0 left-1/2 -translate-x-1/2 animate-ping"></div>
				</div>
				<div className="absolute inset-0 animate-spin">
					<div className="w-6 h-6 bg-(--color-accent-hover) text-(--color-text) rounded-full absolute top-0 left-1/2 -translate-x-1/2"></div>
				</div>
			</div>
			<h2 className="text-3xl font-bold  text-(--color-text-) mb-2">Loading</h2>
			<p className=" text-(--color-text)/80 text-lg">Almost there...</p>
		</div>
	);
};